import React from 'react';
const links = ['Terms & Conditions', 'Privacy Policy', 'Refund Policy', 'Contact'];
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-navy-900 px-4 pb-28 pt-10 text-center sm:px-6" data-id="element-42" data-mp="3ggtx2ezk5d3n">
      <div className="mx-auto w-full max-w-3xl" data-id="element-43" data-mp="32pp7k5pwm171">
        <p className="font-display text-lg font-bold uppercase tracking-[0.1em] text-gold-500" data-id="element-44" data-mp="36oxyl2tk7kyw">
          🔧 Technical System PRO 360™
        </p>
        <nav aria-label="Footer" data-id="element-45" data-mp="3uftmvpyt3y1e">
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-2" data-id="element-46" data-mp="38qtcrvhxfo0">
            {links.map(link => <li key={link} data-id="element-47" data-mp="3lf57aqtrlpme">
                <a href="#offer" className="text-[12px] font-medium text-white/60 underline-offset-4 transition-colors duration-150 ease-out hover:text-white hover:underline sm:text-sm" data-id="element-48" data-mp="3ldu8l5f6f825">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mt-5 text-[11px] leading-relaxed text-white/40 sm:text-xs" data-id="element-49" data-mp="3l9ac9f9lwy2u">
          © 2026 Technical System PRO 360™. All rights reserved.
        </p>
      </div>
    </footer>;
}